document.addEventListener("DOMContentLoaded", function (event) {

    var OKJS = window.OKJS;

    OKJS.Global.init();

    var evtType = 'OKJS.Initialized';
    var evt;
    try {
        evt = new Event(evtType);
    }
    catch (err) {
        //probably IE since it doesn't allow Event constructor. We have to create it the old-fashioned way instead:
        evt = document.createEvent('Event');
        evt.initEvent(evtType, true, true);
    }

    document.dispatchEvent(evt);
});